import { useMemo } from 'react'
import { uniqueId } from 'lodash'

const useUniqueId = (prefix = 'id-') =>
  useMemo(() => uniqueId(prefix), [prefix])

export default useUniqueId
